import { FC } from 'react';
import './Navbar.scss';

import { useNavigate } from 'react-router';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { deIcon, enIcon, kaIcon, koIcon, mellIcon, ptIcon, ruIcon, ukIcon, usdtIcon, zhIcon } from '../../assets';
import { TRootState } from '../../store/store';
import { setOpenLocale } from '../../store/user/user.slice';
import { IAssetItem, ThemeName } from '../../types/navBar';
import { onImagesLoad } from '../../utils/helper';
import Ava from '../Common/Ava/Ava';

interface INavbarProps {
    setTheme: Function;
    theme: ThemeName;
}

// const themes: IThemes = {
//     dark: { link: moonIcon },
//     light: { link: lightIcon },
// };

const assetItems: IAssetItem[] = [
    { link: '/wallet', icon: usdtIcon },
    { link: '/wallet?asset=1', icon: mellIcon },
];

const Navbar: FC<INavbarProps> = () => {
    const wallet = useSelector((state: TRootState) => state.wallet.value);
    const user = useSelector((state: TRootState) => state.user.value);
    const dispatch = useDispatch();
    const { i18n } = useTranslation();

    const navigate = useNavigate();
    return (
        <div className="navbar">
            <div className="ban">
                {assetItems.map(({ link, icon }, i) => (
                    <div
                        key={icon + i}
                        className="balance"
                        onClick={() => navigate(link)}>
                        <img
                            src={icon}
                            alt="balance"
                        />
                        {Number(parseInt(wallet.assets[i].assetBalance ?? 0)).toLocaleString()}
                    </div>
                ))}
            </div>
            <div className="right">
                <div className="set">
                    <span
                        onClick={() =>
                            onImagesLoad([deIcon, enIcon, kaIcon, koIcon, ptIcon, ruIcon, ukIcon, zhIcon], () => dispatch(setOpenLocale(true)))
                        }>
                        {String(i18n.resolvedLanguage).toUpperCase()}
                    </span>
                    {/* <img
                        className="vertical-line"
                        src={verticalLine}
                        alt="line"
                    />
                    <img
                        src={themes[theme].link}
                        alt="themeIcon"
                        onClick={() => setTheme(theme === ThemeName.DARK ? ThemeName.LIGHT : ThemeName.DARK)}
                    /> */}
                </div>

                <div onClick={() => navigate('/profile')}>
                    <Ava
                        width="36px"
                        height="36px"
                        collectionId={user.info.profile.ava.collectionId}
                        entityId={user.info.profile.ava.entityId}
                    />
                </div>
            </div>
        </div>
    );
};

export default Navbar;
